import { StyleSheet } from 'react-native';
import { neutrals, brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: 24,
    paddingHorizontal: 6,
  },
  adjustmentsWrapper: {
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
  },
  adjustmentContainer: {
    marginBottom: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  adjustmentText: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: '400',
    color: neutrals.neutralGrays.graphite,
  },
  valueText: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: '400',
    color: neutrals.neutralGrays.cement,
  },
  ctaButton: {
    backgroundColor: brand.main.water,
    flex: 1,
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 9,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: { width: 2, height: 2 },
    shadowRadius: 4,
  },
  ctaButtonSecondary: {
    borderColor: brand.main.water,
    borderWidth: 1,
    flex: 1,
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 9,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: { width: 2, height: 2 },
    shadowRadius: 4,
  },
  ctaText: {
    fontSize: 16,
    fontWeight: 700,
    color: neutrals.white,
    lineHeight: 22,
  },
  adjustmentsButtonsContainer: {
    flex: 1,
    gap: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 12,
    paddingBottom: 8,
  },
  adjustmentButton: {
    width: 48,
    height: 48,
    padding: 12,
    borderRadius: 24,
  },
  ctasContainer: {
    paddingTop: 16,

    flexDirection: 'row',
    gap: 8,
  },
});
